import type { FC } from 'react';
import saberHandleImg from 'src/images/pngs/campaigns/saber-handle.png';
import { StyledBlade, StyledBladeContainer, StyledContainer, StyledSaber } from './star-wars-saber.styles';
import type { StarWarsSaberProps } from './star-wars-saber.types';
export const StarWarsSaber: FC<StarWarsSaberProps> = ({
  red
}) => <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="StarWarsSaber" data-sentry-source-file="star-wars-saber.tsx">
    <StyledSaber data-sentry-element="StyledSaber" data-sentry-source-file="star-wars-saber.tsx">
      <img src={saberHandleImg} alt="" />
      <StyledBladeContainer data-sentry-element="StyledBladeContainer" data-sentry-source-file="star-wars-saber.tsx">
        <StyledBlade red={red} delay={200 + Math.random() * 700} data-sentry-element="StyledBlade" data-sentry-source-file="star-wars-saber.tsx" />
      </StyledBladeContainer>
    </StyledSaber>
  </StyledContainer>;